import {
  useCreateAlembicRevisionMutation,
  useCreateEntityMutation,
  useGetAllEntitiesQuery,
  useLazyGetEntityDetailsQuery,
  useUdpateEntityMutation,
  useUpgradeAlembicRevisionMutation,
} from "../../../store/services/entityQuery";

export const useEntity = () => {
  const {
    data: getAllEntitiesData,
    isLoading: getAllEntitiesIsLoading,
    isError: getAllEntitiesIsError,
    error: getAllEntitiesError,
    isSuccess: getAllEntitiesIsSuccess,
    refetch: refetchGetAllEntities,
  } = useGetAllEntitiesQuery({});

  const [
    getSelectedEntityDetails,
    {
      data: selectEntityData,
      isLoading: selectEntityIsLoading,
      isError: selectEntityIsError,
      error: selectEntityError,
      isSuccess: selectEntityIsSuccess,
    },
  ] = useLazyGetEntityDetailsQuery();

  const [
    createEntity,
    {
      data: createEntityData,
      isLoading: createEntityIsLoading,
      isError: createEntityIsError,
      error: createEntityError,
      isSuccess: createEntityIsSuccess,
    },
  ] = useCreateEntityMutation();

  const [
    updateEntity,
    {
      data: updateEntityData,
      isLoading: updateEntityIsLoading,
      isError: updateEntityIsError,
      error: updateEntityError,
      isSuccess: updateEntityIsSuccess,
    },
  ] = useUdpateEntityMutation();

  const [
    createAlembicRevision,
    {
      data: createAlembicRevisionData,
      isLoading: createAlembicRevisionIsLoading,
      isError: createAlembicRevisionIsError,
      error: createAlembicRevisionError,
      isSuccess: createAlembicRevisionIsSuccess,
    },
  ] = useCreateAlembicRevisionMutation();

  const [
    upgradeAlembicRevision,
    {
      data: upgradeAlembicRevisionData,
      isLoading: upgradeAlembicRevisionIsLoading,
      isError: upgradeAlembicRevisionIsError,
      error: upgradeAlembicRevisionError,
      isSuccess: upgradeAlembicRevisionIsSuccess,
    },
  ] = useUpgradeAlembicRevisionMutation();

  return {
    getAllEntitiesData,
    getAllEntitiesIsLoading,
    getAllEntitiesIsError,
    getAllEntitiesError,
    getAllEntitiesIsSuccess,
    refetchGetAllEntities,
    getSelectedEntityDetails,
    selectEntityData,
    selectEntityIsLoading,
    selectEntityIsError,
    selectEntityError,
    selectEntityIsSuccess,
    createEntity,
    createEntityData,
    createEntityIsLoading,
    createEntityIsError,
    createEntityError,
    createEntityIsSuccess,
    updateEntity,
    updateEntityData,
    updateEntityIsLoading,
    updateEntityIsError,
    updateEntityError,
    updateEntityIsSuccess,
    createAlembicRevision,
    createAlembicRevisionData,
    createAlembicRevisionIsLoading,
    createAlembicRevisionIsError,
    createAlembicRevisionError,
    createAlembicRevisionIsSuccess,
    upgradeAlembicRevision,
    upgradeAlembicRevisionData,
    upgradeAlembicRevisionIsLoading,
    upgradeAlembicRevisionIsError,
    upgradeAlembicRevisionError,
    upgradeAlembicRevisionIsSuccess,
  };
};
